export const startC4DiagramText = `workspace {

    model {
        user = person "User"
        softwareSystem = softwareSystem "Software System" {
        }

        user -> softwareSystem "Uses"
    }

    views {
        systemContext softwareSystem "Diagram1" {
            include *
            autoLayout
        }

        theme default
    }

}`;

export const c4DiagramIcon = (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.4615 1H1.53846C1.24108 1 1 1.24108 1 1.53846V14.4615C1 14.7589 1.24108 15 1.53846 15H14.4615C14.7589 15 15 14.7589 15 14.4615V1.53846C15 1.24108 14.7589 1 14.4615 1Z"
			fill="#1C4177"
		/>
		<path
			d="M8.04313 7.59131H6.84548C6.82357 7.43639 6.77893 7.29876 6.71146 7.17841C6.64404 7.05629 6.55746 6.95237 6.45171 6.8667C6.34598 6.78103 6.22385 6.71539 6.0853 6.66984C5.94858 6.62428 5.80002 6.60145 5.6396 6.60145C5.34976 6.60145 5.09729 6.6735 4.88218 6.81748C4.66708 6.95969 4.50028 7.16748 4.38179 7.44092C4.2633 7.71252 4.20405 8.04248 4.20405 8.43077C4.20405 8.82998 4.2633 9.16539 4.38179 9.43699C4.5021 9.70865 4.66981 9.91369 4.88491 10.0522C5.10002 10.1908 5.34884 10.2601 5.6314 10.2601C5.78999 10.2601 5.93674 10.2391 6.07163 10.1972C6.20835 10.1552 6.32958 10.0942 6.43528 10.014C6.54104 9.93195 6.62854 9.8326 6.69778 9.71592C6.76891 9.59928 6.81813 9.46618 6.84548 9.3167L8.04313 9.32219C8.01211 9.5792 7.93463 9.82711 7.81068 10.0659C7.68855 10.3029 7.52357 10.5153 7.31577 10.703C7.10976 10.889 6.86368 11.0367 6.57749 11.146C6.29312 11.2535 5.97137 11.3073 5.61226 11.3073C5.11278 11.3073 4.66616 11.1943 4.27241 10.9683C3.88049 10.7422 3.57059 10.415 3.34273 9.98665C3.11669 9.55825 3.00366 9.03961 3.00366 8.43077C3.00366 7.8201 3.11851 7.30054 3.3482 6.87219C3.57788 6.44379 3.8896 6.11749 4.28335 5.89327C4.6771 5.66723 5.12007 5.5542 5.61226 5.5542C5.93674 5.5542 6.23752 5.59978 6.5146 5.69093C6.79352 5.78207 7.04051 5.91514 7.25563 6.09014C7.47074 6.26332 7.64574 6.47567 7.78063 6.72724C7.91734 6.97881 8.00484 7.26683 8.04313 7.59131ZM8.77458 10.2464V9.31395L11.1125 5.63077H11.9163V6.92141H11.4406L9.96673 9.25381V9.29758H13.289V10.2464H8.77458ZM11.4625 11.2308V9.96199L11.4843 9.54915V5.63077H12.5945V11.2308H11.4625Z"
			fill="white"
		/>
	</svg>
);
